import Link, { type LinkProps } from '@mui/material/Link';
import { createLink } from '@tanstack/react-router';
import { forwardRef } from 'react';

const TextLinkInner = forwardRef<HTMLAnchorElement, LinkProps<'a'>>((props, ref) => {
    return <Link ref={ref} component="a" {...props} />;
});

TextLinkInner.displayName = 'TextLinkInner';

export const TextLink = createLink(TextLinkInner);
